module.exports = __webpack_public_path__ + "img/portrait-002.a959a857.jpg";